/** Merge customer_ids into API query/body params (FastAPI repeated query style). */
export function withCustomerIds(params = {}, customerIds = []) {
  const out = { ...params }
  if (customerIds?.length) {
    out.customer_ids = customerIds.map(Number)
  }
  return out
}
